const ReservationColorType = {
  STATUT: 1,
  ACTIVITE: 2,
  RESERVANT: 3,
};

export default ReservationColorType;
